export default "__VITE_ASSET__BXt2OUpC__"